import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AccountType } from '@model/AccountType'

import { useScrollToTop } from '@hooks/useScrollToTop'

import { Box } from '@shared/components/Box'

import { SignupFormWrapper } from '../../../Components/SignupFormWrapper'
import { SignupSections, SignupStep } from '../../../Components/SignupStep'
import { VerifyLeadUsingOTP } from '../verifyLeadUsingOTP/VerifyLeadUsingOTP'

interface OTPVerificationPageProps {
  step: number
  email: string
  accountTypeId: AccountType
  totalSteps: number
  onResend(event: React.MouseEvent<HTMLElement>): void
  onVerifyCode(code: string): Promise<void>
  onNext(): Promise<void>
}

const OTPVerificationPage: React.FC<OTPVerificationPageProps> = ({
  step,
  totalSteps,
  onResend,
  email,
  accountTypeId,
  onVerifyCode,
  onNext,
}) => {
  const { t } = useTranslation()
  const [isContinuing, setIsContinuing] = useState(false)
  useScrollToTop()

  const handleContinue = useCallback(async () => {
    try {
      setIsContinuing(true)
      await onNext()
    } finally {
      setIsContinuing(false)
    }
  }, [onNext])

  return (
    <SignupFormWrapper id='lead-created-page' label={t('Sign up.Sign up')}>
      <SignupStep
        subStep={{
          current: step,
          total: totalSteps,
        }}
        label={t('Sign up.Confirm Registration')}
        section={SignupSections.PersonalDetails}
        accountTypeId={accountTypeId}
      />

      <Box flex align='center' justify='center' fullWidth fullHeight wrap mt='x24'>
        <VerifyLeadUsingOTP
          email={email}
          onResend={onResend}
          onVerifyCode={onVerifyCode}
          onContinue={handleContinue}
          continueLoading={isContinuing}
        />
      </Box>
    </SignupFormWrapper>
  )
}

export default OTPVerificationPage
